import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { ProjectStatus } from '@camelot/services';

import { CamProjectStatusComponent } from './project-status.component';

@Component({
  host: { 'data-cid': 'grid-project-status-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [CamProjectStatusComponent],
  template: `
    @if (this.value !== null && this.value !== undefined) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-project-status class="d-flex" [status]="this.value"></cam-project-status>
      </div>
    }
  `,
})
export class GridProjectStatusCellComponent extends AbstractCellComponent<any, ProjectStatus> {}
